"use client"

import { useEffect, useRef, useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { MessageCircle, X } from "lucide-react"
import "./WhatsappButton.css";

type WhatsAppButtonProps = {
  onContactClick: () => void;
};

export default function WhatsAppButton({ onContactClick }: WhatsAppButtonProps) {
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const [bottomOffset, setBottomOffset] = useState(24);
  const buttonRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const updatePosition = () => {
      const footer = buttonRef.current?.closest(".site-footer");

      if (!footer) {
        return;
      }

      const footerRect = footer.getBoundingClientRect();
      const buttonHeight = buttonRef.current?.offsetHeight ?? 64;
      const floatingOffset = 24;
      const nextBottom = Math.max(
        floatingOffset,
        window.innerHeight - footerRect.top + floatingOffset,
      );

      setBottomOffset(
        footerRect.top <= window.innerHeight - (buttonHeight + floatingOffset)
          ? nextBottom
          : floatingOffset,
      );
    };

    updatePosition();

    window.addEventListener("scroll", updatePosition, { passive: true });
    window.addEventListener("resize", updatePosition);

    return () => {
      window.removeEventListener("scroll", updatePosition);
      window.removeEventListener("resize", updatePosition);
    };
  }, []);

  return (
    <div
      ref={buttonRef}
      className="fixed right-6 z-50"
      style={{ bottom: `${bottomOffset}px` }}
    >
      <AnimatePresence>
        {tooltipVisible && (
          <motion.div
            initial={{ opacity: 0, scale: 0.8, x: -20 }}
            animate={{ opacity: 1, scale: 1, x: 0 }}
            exit={{ opacity: 0, scale: 0.8, x: -20 }}
            className="absolute bottom-full right-0 mb-2 bg-white rounded-lg shadow-lg p-3 w-64"
          >
            <button
              className="absolute top-2 right-2 text-gray-400 hover:text-gray-600 bg-transparent border-none"
              onClick={() => setTooltipVisible(false)}
            >
              <X size={16} />
            </button>
            <p className="text-sm text-gray-700">
              ¿Necesitas ayuda? Contáctanos y te responderemos a la brevedad.
            </p>
          </motion.div>
        )}
      </AnimatePresence>
{/** 112d63 */}

      <motion.button
        type="button"
        className="flex items-center justify-center w-16 h-16 bg-[#112d63] rounded-full shadow-lg text-white"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        onClick={onContactClick}
        onMouseEnter={() => setTooltipVisible(true)}
        aria-label="Abrir formulario de contacto"
      >
        <MessageCircle size={30} fill="white" />
      </motion.button>
    </div>
  )
}
